import {
  GET_ORDER_VEHICLE_LIST,
  GET_ORDER_VEHICLE_LIST_OK,
  GET_ORDER_VEHICLE_LIST_ERR,
  DO_ORDER_VEHICLE_LIST_CLEANUP,
  ADD_ORDER_VEHICLE,
  ADD_ORDER_VEHICLE_OK,
  ADD_ORDER_VEHICLE_ERR,
  EDIT_ORDER_VEHICLE,
  EDIT_ORDER_VEHICLE_OK,
  EDIT_ORDER_VEHICLE_ERR,
  DELETE_ORDER_VEHICLE,
  DELETE_ORDER_VEHICLE_OK,
  DELETE_ORDER_VEHICLE_ERR,
} from './actionTypes';

// List actions
export const getOrderVehicleList = (orderId) => {
  return {
    type: GET_ORDER_VEHICLE_LIST,
    payload: { orderId },
  };
};

export const getOrderVehicleListOk = response => ({
  type: GET_ORDER_VEHICLE_LIST_OK,
  payload: { response },
});

export const getOrderVehicleListErr = error => ({
  type: GET_ORDER_VEHICLE_LIST_ERR,
  payload: { error },
});

export const doOrderVehicleListCleanup = () => ({
  type: DO_ORDER_VEHICLE_LIST_CLEANUP,
});

// Add actions
export const addOrderVehicle = (orderId, vehicleData) => ({
  type: ADD_ORDER_VEHICLE,
  payload: { orderId, vehicleData },
});

export const addOrderVehicleOk = response => ({
  type: ADD_ORDER_VEHICLE_OK,
  payload: { response },
});

export const addOrderVehicleErr = error => ({
  type: ADD_ORDER_VEHICLE_ERR,
  payload: { error },
});

export const editOrderVehicle = (vehicleId, vehicleData) => ({
  type: EDIT_ORDER_VEHICLE,
  payload: { vehicleId, vehicleData },
});

export const editOrderVehicleOk = response => ({
  type: EDIT_ORDER_VEHICLE_OK,
  payload: { response },
});

export const editOrderVehicleErr = error => ({
  type: EDIT_ORDER_VEHICLE_ERR,
  payload: { error },
});

// Delete actions
export const deleteOrderVehicle = (vehicleId) => ({
  type: DELETE_ORDER_VEHICLE,
  payload: { vehicleId },
});

export const deleteOrderVehicleOk = response => ({
  type: DELETE_ORDER_VEHICLE_OK,
  payload: { response },
});

export const deleteOrderVehicleErr = error => ({
  type: DELETE_ORDER_VEHICLE_ERR,
  payload: { error },
});